/* import __COLOCATED_TEMPLATE__ from './period.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { DayOfWeek } from '@square/dashboard-items-data/models/connect/availability-period/data';
import { inject as service } from '@ember/service';
const KEY_NAME_ENTER = 'Enter';
let Period = (_dec = service('availability/availability-periods-manager'), _class = class Period extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "availabilityPeriodsManager", _descriptor2, this);
    _defineProperty(this, "id", null);
    if (args.availabilityPeriod) {
      this.id = args.availabilityPeriod.availabilityPeriodModel.idOrTempId();
    }
  }
  get dayLabel() {
    switch (this.args.dayOfWeek) {
      case DayOfWeek.SUN:
        return this.intl.t('sharedUi.day.sunday');
      case DayOfWeek.MON:
        return this.intl.t('sharedUi.day.monday');
      case DayOfWeek.TUE:
        return this.intl.t('sharedUi.day.tuesday');
      case DayOfWeek.WED:
        return this.intl.t('sharedUi.day.wednesday');
      case DayOfWeek.THU:
        return this.intl.t('sharedUi.day.thursday');
      case DayOfWeek.FRI:
        return this.intl.t('sharedUi.day.friday');
      case DayOfWeek.SAT:
        return this.intl.t('sharedUi.day.saturday');
      default:
        return '';
    }
  }
  get isFirstInDay() {
    return this.args.dayIndex === 0;
  }
  get startTime() {
    return this.args.availabilityPeriod?.availabilityPeriodModel.startLocalTime ?? null;
  }
  get endTime() {
    return this.args.availabilityPeriod?.availabilityPeriodModel.endLocalTime ?? null;
  }
  get isDayChecked() {
    return Boolean(this.args.availabilityPeriod);
  }
  get errorStartText() {
    if (!this.args.availabilityPeriod) {
      return '';
    }
    if (this.args.availabilityPeriod.isPeriodLessThanMinimumDuration) {
      return '';
    }
    return this.intl.t('sharedUi.availability.period.overlappingHours');
  }
  get errorEndText() {
    if (!this.args.availabilityPeriod) {
      return '';
    }
    if (this.args.availabilityPeriod.isPeriodLessThanMinimumDuration) {
      return this.intl.t('sharedUi.availability.period.lessThanMinimumDuration', {
        duration: this.args.availabilityPeriod.minimumDurationMinutes
      });
    }
    return this.intl.t('sharedUi.availability.period.overlappingHours');
  }
  get isEndTimeNextDay() {
    if (!this.args.availabilityPeriod) {
      return false;
    }
    return this.args.availabilityPeriod.isEndTimeNextDay;
  }

  // This handles an edge case. If the end time is 23:45:00 we want to prevent adding a new availability period
  get isEndTime1145PM() {
    if (!this.args.availabilityPeriod) {
      return false;
    }
    return this.args.availabilityPeriod.availabilityPeriodModel.endLocalTime === '23:45:00';
  }
  get shouldDisplayAddButton() {
    return this.isDayChecked && !this.isEndTimeNextDay && !this.isEndTime1145PM;
  }
  get shouldDisplayDeleteButton() {
    return !this.args.doesDayHaveOneAvailabilityPeriod && this.isDayChecked;
  }
  onAvailabilityChange({
    value,
    isStart
  }) {
    if (!this.args.availabilityPeriod) {
      return;
    }
    const changeArgs = {
      id: this.args.availabilityPeriod.availabilityPeriodModel.idOrTempId(),
      dayOfWeek: this.args.availabilityPeriod.availabilityPeriodModel.dayOfWeek,
      startLocalTime: this.args.availabilityPeriod.availabilityPeriodModel.startLocalTime,
      endLocalTime: this.args.availabilityPeriod.availabilityPeriodModel.endLocalTime
    };
    if (isStart) {
      changeArgs.startLocalTime = value;
    } else {
      changeArgs.endLocalTime = value;
    }
    this.availabilityPeriodsManager.handleAvailabilityPeriodChange(changeArgs);
  }
  handleCheckboxKeyUp(e) {
    if (e.key !== KEY_NAME_ENTER) {
      return;
    }
    this.args.toggleIsDayChecked();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "availabilityPeriodsManager", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onAvailabilityChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAvailabilityChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCheckboxKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCheckboxKeyUp"), _class.prototype), _class);
export { Period as default };